import type { ReviewerDisplayMode } from "../../atoms/reviewerPrefsAtoms";

const OPTIONS: { value: ReviewerDisplayMode; label: string; title: string }[] = [
  {
    value: "inline",
    label: "Inline",
    title: "Findings as chips in the report; right-click to judge",
  },
  {
    value: "list",
    label: "List",
    title: "Card list with always-visible agree/disagree/skip buttons",
  },
];

interface Props {
  mode: ReviewerDisplayMode;
  onChange: (mode: ReviewerDisplayMode) => void;
}

export function ReviewerDisplayToggle({ mode, onChange }: Props) {
  return (
    <div
      className="reporter-mode-toggle"
      role="radiogroup"
      aria-label="Reviewer display mode"
      data-testid="reviewer-display-toggle"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={mode === opt.value}
          title={opt.title}
          data-testid={`reviewer-display-${opt.value}`}
          className={`reporter-mode-toggle__option ${mode === opt.value ? "reporter-mode-toggle__option--active" : ""}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
